import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import * as React from 'react';
import { RootZone } from './RootZone';
import { useClientPortalView } from './useClientPortalView';
import { LoadingMode, useViewState } from './useViewState';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export { isContainerUseViewStateProps as isContainerViewLoaderProps, isSpecificViewRIDUseViewStateProps as isSpecificViewRIDLoaderProps } from './useViewState';
export function ViewLoader(props) {
  var piletApi = props.piletApi,
    fallbackView = props.fallbackView,
    loadingMode = props.loadingMode,
    viewContext = props.viewContext,
    contractData = props.contractData,
    onCompleteInteraction = props.onCompleteInteraction,
    onCancelInteraction = props.onCancelInteraction;
  var contractDataWithFallback = contractData !== null && contractData !== void 0 ? contractData : viewContext;
  var _useViewState = useViewState(props),
    status = _useViewState.status,
    views = _useViewState.views;
  var clientPortalView = useClientPortalView(views);
  if ([LoadingMode.FallbackOnly, LoadingMode.FallbackButLoadInBackground].includes(loadingMode)) {
    return /*#__PURE__*/_jsx(RootZone, {
      piletApi: piletApi,
      allViews: [fallbackView],
      contractData: contractDataWithFallback,
      onCompleteInteraction: onCompleteInteraction,
      onCancelInteraction: onCancelInteraction
    });
  }
  if (status === 'not-requested' || status === 'loading') {
    var _props$loader;
    return /*#__PURE__*/_jsx(_Fragment, {
      children: (_props$loader = props.loader) !== null && _props$loader !== void 0 ? _props$loader : null
    });
  }
  return /*#__PURE__*/_jsx(RootZone, {
    piletApi: piletApi,
    allViews: views ? [].concat(_toConsumableArray(views), [fallbackView]) : [fallbackView],
    startingViewRID: views && isContainerViewLoaderProps(props) ? clientPortalView ? clientPortalView.rid : props.startingViewRID : undefined,
    contractData: contractDataWithFallback,
    onCompleteInteraction: onCompleteInteraction,
    onCancelInteraction: onCancelInteraction
  });
}
function isContainerViewLoaderProps(props) {
  return props.hasOwnProperty('containerRID') && !props.hasOwnProperty('viewId');
}